module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('header-top'), _vm._v(" "), _c('div', {
    staticClass: "shelves-content"
  }, [_c('div', {
    staticClass: "main-width"
  }, [_c('div', {
    staticClass: "shelves-left"
  }, [_c('el-col', [_c('el-menu', {
    staticClass: "el-menu-vertical-demo",
    attrs: {
      "default-active": _vm.defaultActive,
      "default-openeds": _vm.defaultOpen
    },
    on: {
      "select": _vm.setStatus
    }
  }, [_c('el-submenu', {
    attrs: {
      "index": "1"
    }
  }, [_c('template', {
    slot: "title"
  }, [_vm._v("我的货架")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "1-0",
      "default-active": true
    }
  }, [_c('template', {
    slot: "title"
  }, [_vm._v("全部 （" + _vm._s(_vm.kindNumber.all) + "）")])], 2), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "1-1"
    }
  }, [_c('template', {
    slot: "title"
  }, [_vm._v("未生效 (" + _vm._s(_vm.kindNumber.noSend) + ")")])], 2), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "1-2"
    }
  }, [_c('template', {
    slot: "title"
  }, [_vm._v("有更优价格 （" + _vm._s(_vm.kindNumber.betterPrice) + "）")])], 2), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "1-3"
    }
  }, [_c('template', {
    slot: "title"
  }, [_vm._v("货源已涨价 （" + _vm._s(_vm.kindNumber.riseFailure) + "）")])], 2), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "1-4"
    }
  }, [_c('template', {
    slot: "title"
  }, [_vm._v("断货 （" + _vm._s(_vm.kindNumber.noInventory) + "）")])], 2), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "1-7"
    }
  }, [_c('template', {
    slot: "title"
  }, [_vm._v("区域断货 （" + _vm._s(_vm.kindNumber.duangong) + "）")])], 2), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "1-6"
    }
  }, [_c('template', {
    slot: "title"
  }, [_vm._v("自产自销 （" + _vm._s(_vm.kindNumber.isOwnsNum) + "）")])], 2), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "1-5"
    }
  }, [_c('template', {
    slot: "title"
  }, [_vm._v("正常生效 （" + _vm._s(_vm.kindNumber.normalSales) + "）")])], 2)], 2), _vm._v(" "), _c('el-menu-item', {
    staticClass: "shopCar",
    attrs: {
      "index": "2"
    },
    on: {
      "click": function($event) {
        return _vm.onRecycle()
      }
    }
  }, [_c('span', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("商品回收站")])]), _vm._v(" "), (_vm.openPurchasingCart == 1) ? _c('el-menu-item', {
    staticClass: "shopCar",
    attrs: {
      "index": "3"
    },
    on: {
      "click": function($event) {
        return _vm.showShopCar(2)
      }
    }
  }, [_c('span', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("采购车")])]) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "shelves-right"
  }, [(!_vm.shopCarShow) ? _c('div', {
    staticClass: "shelves-right-wrap"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShow),
      expression: "isShow"
    }],
    staticClass: "goods-shelves"
  }, [_c('div', {
    staticClass: "shelves-filter-wrap"
  }, [_c('span', {
    staticClass: "shelves-input-item"
  }, [_c('label', [_vm._v("SKU：")]), _vm._v(" "), _c('span', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.condition.productId),
      expression: "condition.productId"
    }],
    attrs: {
      "type": "text",
      "placeholder": "请输入SKU"
    },
    domProps: {
      "value": (_vm.condition.productId)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.condition, "productId", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('span', {
    staticClass: "shelves-input-item"
  }, [_c('label', [_vm._v("品牌名称：")]), _vm._v(" "), _c('span', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.condition.brandName),
      expression: "condition.brandName"
    }],
    attrs: {
      "type": "text",
      "placeholder": "请输入品牌名称"
    },
    domProps: {
      "value": (_vm.condition.brandName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.condition, "brandName", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('span', {
    staticClass: "shelves-input-item"
  }, [_c('label', [_vm._v("商品名称：")]), _vm._v(" "), _c('span', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.condition.goodsName),
      expression: "condition.goodsName"
    }],
    attrs: {
      "type": "text",
      "placeholder": "请输入商品名称"
    },
    domProps: {
      "value": (_vm.condition.goodsName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.condition, "goodsName", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('span', {
    staticClass: "shelves-input-item"
  }, [_c('label', [_vm._v("二级分类：")]), _vm._v(" "), _c('span', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.condition.twoLevel),
      expression: "condition.twoLevel"
    }],
    attrs: {
      "type": "text",
      "placeholder": "请输入二级分类"
    },
    domProps: {
      "value": (_vm.condition.twoLevel)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.condition, "twoLevel", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('span', {
    staticClass: "shelves-input-item"
  }, [_c('label', [_vm._v("三级分类：")]), _vm._v(" "), _c('span', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.condition.threeLevel),
      expression: "condition.threeLevel"
    }],
    attrs: {
      "type": "text",
      "placeholder": "请输入三级分类"
    },
    domProps: {
      "value": (_vm.condition.threeLevel)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.condition, "threeLevel", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('span', {
    staticStyle: {
      "margin-left": "10px"
    }
  }, [_c('span', {
    staticClass: "shelves-filter-btn-default shelves-filter",
    on: {
      "click": _vm.init
    }
  }, [_vm._v("筛选")]), _vm._v(" "), _c('span', {
    staticClass: "shelves-filter-btn-default shelves-cancel",
    on: {
      "click": _vm.clearCondition
    }
  }, [_vm._v("取消")])])]), _vm._v(" "), _c('div', {
    staticClass: "mar-top-15 operation"
  }, [_c('div', {
    staticClass: "batch-operation el-button el-button--primary el-button--small",
    staticStyle: {
      "height": "30px",
      "margin-left": "0",
      "margin-right": "20px"
    },
    on: {
      "click": function($event) {
        return _vm.newPush(null)
      }
    }
  }, [_c('span', [_vm._v("批量推送")])]), _vm._v(" "), _c('div', {
    staticClass: "batch-operation el-button el-button--primary el-button--small",
    staticStyle: {
      "height": "30px"
    },
    on: {
      "click": _vm.putInbin
    }
  }, [_c('span', [_vm._v("批量放入回收站")])]), _vm._v(" "), _c('div', {
    staticClass: "batch-operation ineffective-operation el-button el-button--primary el-button--small",
    staticStyle: {
      "height": "30px",
      "float": "right"
    },
    on: {
      "click": _vm.pushIneffective
    }
  }, [_vm._v("推送所有未生效信息")])]), _vm._v(" "), _c('div', [(_vm.isShowImg) ? _c('div', {
    staticClass: "noData"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/img/erro@2x.png")
    }
  }), _vm._v(" "), _c('p', [_vm._v("暂未发现任何商品")])]) : _vm._e(), _vm._v(" "), (!_vm.isShowImg) ? _c('table', {
    staticClass: "shelves-table"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "table-header-selectall",
    class: {
      'yigouxuan': _vm.isSelect
    },
    on: {
      "click": _vm.allSelect
    }
  }, [_vm._v("全选")]), _vm._v(" "), _c('th', [_vm._v("操作")]), _vm._v(" "), _c('th', [_vm._v("货品SKU")]), _vm._v(" "), _c('th', [_vm._v("类型")]), _vm._v(" "), _c('th', [_vm._v("建议售价")]), _vm._v(" "), _c('th', [_vm._v("结算价 (+运费）")]), _vm._v(" "), _c('th', [_vm._v("可供库存")]), _vm._v(" "), _c('th', [_vm._v("是否带票")]), _vm._v(" "), _c('th', [_vm._v("利润率")]), _vm._v(" "), _c('th', [_vm._v("状态")])]), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _vm._l((_vm.goodsList), function(item, index) {
    return _c('tbody', [_c('tr', [_c('td', {
      staticClass: "shelves-table-block-title",
      class: {
        'yigouxuan': _vm.selectItem[index].isSelect
      },
      attrs: {
        "colspan": "10"
      },
      on: {
        "click": function($event) {
          return _vm.selectItemAll(index)
        }
      }
    }, [_c('span', [_vm._v("\n                          商品品牌：\n                          "), _c('label', [_vm._v(_vm._s(item.brand))])]), _vm._v(" "), (item.channel === 2) ? _c('span', {
      staticClass: "shelves-table-block-name dianshang"
    }, [_vm._v("商品名称：" + _vm._s(item.goodsName))]) : (item.channel === 1) ? _c('span', {
      staticClass: "shelves-table-block-name mendian"
    }, [_vm._v("商品名称：" + _vm._s(item.goodsName))]) : _c('span', {
      staticClass: "shelves-table-block-name"
    }, [_vm._v("商品名称：" + _vm._s(item.goodsName))]), _vm._v(" "), _c('span', [_c('label', [_vm._v(_vm._s(item.twoLevel) + " / " + _vm._s(item.threeLevel))])])])]), _vm._v(" "), _vm._l((item.goodsShelfDetails), function(value, index1) {
      return _c('tr', {
        staticClass: "shelves-table-item hasborder",
        class: value.skuId == (item.goodsShelfDetails[index1 + 1] ? item.goodsShelfDetails[index1 + 1].skuId : null) ? 'tr-td-style' : ''
      }, [(_vm.selectItem[index].shelvesProduct[index1].isSelect) ? _c('td', {
        staticClass: "shelves-table-item-select",
        class: {
          'yigouxuan': _vm.selectItem[index].shelvesProduct[index1].isChecked
        },
        on: {
          "click": function($event) {
            return _vm.selectItemFuc(index, index1)
          }
        }
      }) : _c('td', {
        staticClass: "shelves-table-item-default"
      }), _vm._v(" "), _c('td', [_c('div', [(_vm.selectItem[index].shelvesProduct[index1].status0 == '0') ? _c('div', {
        staticClass: "font-color-green cursor-pointer shelves-to-detail td-div-marBot",
        on: {
          "click": function($event) {
            return _vm.newPush(value.goodsShelfByTypes[0].appRecordId)
          }
        }
      }, [_vm._v("推送")]) : (_vm.selectItem[index].shelvesProduct[index1].status0 == '4' && _vm.openPurchasingCart == 1 || _vm.selectItem[index].shelvesProduct[index1].status0 == '7' && _vm.openPurchasingCart == 1) ? _c('div', {
        staticClass: "font-color-red cursor-pointer td-div-marBot",
        on: {
          "click": function($event) {
            return _vm.joinCar(item, value)
          }
        }
      }, [_vm._v("加入采购车")]) : (_vm.selectItem[index].shelvesProduct[index1].status1 == '7') ? _c('div', {
        staticClass: "font-color-orange cursor-pointer td-div-marBot",
        on: {
          "click": function($event) {
            return _vm.newPush(value.goodsShelfByTypes[0].appRecordId)
          }
        }
      }, [_vm._v("\n                            更新推送\n                            "), (_vm.openPurchasingCart == 1) ? _c('div', {
        staticClass: "font-color-red cursor-pointer td-div-marBot",
        on: {
          "click": function($event) {
            $event.stopPropagation();
            return _vm.joinCar(item, value)
          }
        }
      }, [_vm._v("加入采购车")]) : _vm._e()]) : (_vm.selectItem[index].shelvesProduct[index1].status1 == '6') ? _c('div', {
        staticClass: "font-color-orange cursor-pointer td-div-marBot",
        on: {
          "click": function($event) {
            return _vm.newPush(value.goodsShelfByTypes[0].appRecordId)
          }
        }
      }, [_vm._v("更新推送")]) : _vm._e()])]), _vm._v(" "), (value.skuId != (item.goodsShelfDetails[index1 - 1] ? item.goodsShelfDetails[index1 - 1].skuId : null)) ? _c('td', {
        staticClass: "shelves-table-item-img",
        attrs: {
          "rowspan": value.skuId == (item.goodsShelfDetails[index1 + 1] ? item.goodsShelfDetails[index1 + 1].skuId : null) ? 2 : 1
        }
      }, [_c('div', {
        staticClass: "shelves-table-item-imgwrap"
      }, [_c('router-link', {
        attrs: {
          "tag": "a",
          "target": "_blank",
          "to": {
            name: 'Detail',
            query: {
              goodsId: item.goodsId
            }
          }
        }
      }, [_c('img', {
        staticStyle: {
          "top": "50%",
          "transform": "translateY(-50%)"
        },
        attrs: {
          "src": value.pictureUrl
        },
        on: {
          "error": function($event) {
            return _vm.error(1)
          }
        }
      })]), _vm._v(" "), (value.isOwntips == true) ? _c('img', {
        staticStyle: {
          "width": "22px",
          "height": "22px",
          "position": "absolute",
          "z-index": "100",
          "top": "initial",
          "margin-top": "-11px"
        },
        attrs: {
          "src": require("../assets/img/is_owns.png"),
          "alt": ""
        }
      }) : _vm._e()], 1), _vm._v(" "), _c('div', {
        staticClass: "text-align-left td-div-marBot"
      }, [_vm._v(_vm._s(value.specName))]), _vm._v(" "), _c('div', {
        staticClass: "text-align-left"
      }, [_vm._v("\n                          SKU：\n                          "), _c('span', [_vm._v(_vm._s(value.skuId))])])]) : _vm._e(), _vm._v(" "), _c('td', [(value.apiType == 2) ? _c('div', {
        staticClass: "jicai-style"
      }, [_vm._v("社群集采")]) : _c('div', {
        staticClass: "jicai-style"
      }, [_vm._v("一件代发")])]), _vm._v(" "), _c('td', [_vm._l((value.goodsShelfByTypes), function(product) {
        return _c('div', {
          staticClass: "td-div-marBot"
        }, [_vm._v("¥" + _vm._s(product.salePrice / 100) + "\n                        ")])
      }), _vm._v(" "), (value.goodsShelfByTypes[0].limitPrice == 1) ? _c('el-popover', {
        attrs: {
          "trigger": "hover",
          "placement": "top",
          "visible-arrow": "false",
          "width": "300",
          "popper-class": "table-popover"
        }
      }, [_c('div', {
        staticClass: "popover-center"
      }, [_vm._v("\n                            该商品品牌方控价，请按售价对外销售，擅自降价将会终止供应链供货！\n                          ")]), _vm._v(" "), _c('div', {
        attrs: {
          "slot": "reference"
        },
        slot: "reference"
      }, [_c('div', {
        staticClass: "price-control-tips"
      }, [_vm._v("零售控价")])])]) : _vm._e()], 2), _vm._v(" "), _c('td', _vm._l((value.goodsShelfByTypes), function(product) {
        return _c('div', [(value.apiType == 2) ? _c('div', {
          staticClass: "font-color-orange td-div-marBot"
        }, [_vm._v("¥" + _vm._s(product.coopPrice / 100))]) : _c('div', {
          staticClass: "font-color-orange td-div-marBot"
        }, [_vm._v("\n                            ¥" + _vm._s(product.coopPrice / 100) + "\n                            "), _c('span', {
          staticClass: "goods-freight"
        }, [_vm._v("(+" + _vm._s(product.freight / 100) + ")")])])])
      }), 0), _vm._v(" "), _c('td', _vm._l((value.goodsShelfByTypes), function(product, idx) {
        return _c('div', [(product.hasTax == 0) ? _c('div', {
          staticClass: "font-color-orange td-div-marBot"
        }, [_vm._v(_vm._s(product.num))]) : _c('div', {
          staticClass: "font-color-orange td-div-marBot"
        }, [_vm._v(_vm._s(product.num))]), _vm._v(" "), (product.isOwns == 1 && idx == value.goodsShelfByTypes.length - 1) ? _c('div', {
          staticStyle: {
            "color": "rgb(88, 191, 106)",
            "border-radius": "12px",
            "width": "60px",
            "height": "18px",
            "border": "1px solid",
            "font-size": "12px",
            "margin": "0 auto"
          }
        }, [_vm._v("自产自销")]) : _vm._e()])
      }), 0), _vm._v(" "), _c('td', _vm._l((value.goodsShelfByTypes), function(product) {
        return _c('div', [(product.hasTax == 1) ? _c('div', {
          staticClass: "font-color-orange td-div-marBot"
        }, [_vm._v("带票")]) : _c('div', {
          staticClass: "font-color-orange td-div-marBot"
        }, [_vm._v("不带票")])])
      }), 0), _vm._v(" "), _c('td', _vm._l((value.goodsShelfByTypes), function(product) {
        return _c('div', [_c('div', {
          staticClass: "font-color-orange td-div-marBot"
        }, [_vm._v(_vm._s(product.profit) + "%")])])
      }), 0), _vm._v(" "), _c('td', [_c('div', [(_vm.selectItem[index].shelvesProduct[index1].status0 == '3') ? _c('div', {
        staticClass: "td-div-marBot"
      }, [_c('span', [_vm._v("实时价格线")])]) : _vm._e(), _vm._v(" "), (_vm.selectItem[index].shelvesProduct[index1].status0 == '0') ? _c('div', {
        staticClass: "font-color-green cursor-pointer td-div-marBot"
      }, [_vm._v("未推送更新")]) : _vm._e(), _vm._v(" "), (_vm.selectItem[index].shelvesProduct[index1].status0 == '4' || _vm.selectItem[index].shelvesProduct[index1].status0 == '7') ? _c('div', {
        staticClass: "font-color-green cursor-pointer td-div-marBot"
      }, [_vm._v("生效中")]) : _vm._e(), _vm._v(" "), (_vm.selectItem[index].shelvesProduct[index1].status0 == '1' || _vm.selectItem[index].shelvesProduct[index1].status0 == '5') ? _c('div', {
        staticClass: "font-color-red cursor-pointer td-div-marBot"
      }, [_vm._v("断货")]) : _vm._e(), _vm._v(" "), (_vm.selectItem[index].shelvesProduct[index1].status0 == 'new_1') ? _c('div', {
        staticClass: "font-color-red cursor-pointer td-div-marBot"
      }, [_vm._v("区域断货")]) : _vm._e(), _vm._v(" "), (_vm.selectItem[index].shelvesProduct[index1].status0 == 'new_2') ? _c('div', {
        staticClass: "font-color-red cursor-pointer td-div-marBot"
      }, [_vm._v("区域断货未推送")]) : _vm._e(), _vm._v(" "), (_vm.selectItem[index].shelvesProduct[index1].status0 == 'new_3') ? _c('div', {
        staticClass: "font-color-red cursor-pointer td-div-marBot"
      }, [_vm._v("断货未推送")]) : _vm._e(), _vm._v(" "), (_vm.selectItem[index].shelvesProduct[index1].status0 == '6') ? _c('div', {
        staticClass: "font-color-red cursor-pointer td-div-marBot"
      }, [_vm._v("涨价失效")]) : _vm._e()]), _vm._v(" "), (_vm.selectItem[index].shelvesProduct[index1].status1 !== '') ? _c('div', [_c('div', [(_vm.selectItem[index].shelvesProduct[index1].status1 == '0') ? _c('span', {
        staticClass: "td-div-marBot"
      }, [_vm._v("未推送更新")]) : _vm._e(), _vm._v(" "), (_vm.selectItem[index].shelvesProduct[index1].status1 == '3') ? _c('span', {
        staticClass: "td-div-marBot"
      }, [_vm._v("实时价格线")]) : _vm._e()]), _vm._v(" "), (_vm.selectItem[index].shelvesProduct[index1].status1 == '4' || _vm.selectItem[index].shelvesProduct[index1].status1 == '7') ? _c('div', {
        staticClass: "font-color-green cursor-pointer td-div-marBot"
      }, [_vm._v("生效中")]) : _vm._e(), _vm._v(" "), (_vm.selectItem[index].shelvesProduct[index1].status1 == '5') ? _c('div', {
        staticClass: "font-color-red cursor-pointer td-div-marBot"
      }, [_vm._v("断货")]) : _vm._e(), _vm._v(" "), (_vm.selectItem[index].shelvesProduct[index1].status1 == '6') ? _c('div', {
        staticClass: "font-color-red cursor-pointer td-div-marBot"
      }, [_vm._v("涨价失效")]) : _vm._e()]) : _vm._e()])])
    })], 2)
  })], 2) : _vm._e()]), _vm._v(" "), (!_vm.isShowImg) ? _c('div', {
    staticClass: "block"
  }, [_c('el-pagination', {
    attrs: {
      "layout": "prev, pager, next",
      "current-page": _vm.condition.pageNum,
      "total": _vm.goodsCount,
      "page-size": 50
    },
    on: {
      "current-change": _vm.handleCurrentChange,
      "update:currentPage": function($event) {
        return _vm.$set(_vm.condition, "pageNum", $event)
      },
      "update:current-page": function($event) {
        return _vm.$set(_vm.condition, "pageNum", $event)
      }
    }
  })], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isShow),
      expression: "!isShow"
    }],
    staticClass: "recycle-bin-shelves"
  }, [_c('div', {
    staticClass: "shelves-filter-wrap"
  }, [_c('span', {
    staticClass: "shelves-input-item"
  }, [_c('label', [_vm._v("品牌名称：")]), _vm._v(" "), _c('span', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.binFilterObj.brandName),
      expression: "binFilterObj.brandName"
    }],
    attrs: {
      "type": "text",
      "placeholder": "请输入品牌名称"
    },
    domProps: {
      "value": (_vm.binFilterObj.brandName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.binFilterObj, "brandName", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('span', {
    staticClass: "shelves-input-item"
  }, [_c('label', [_vm._v("商品名称：")]), _vm._v(" "), _c('span', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.binFilterObj.goodsName),
      expression: "binFilterObj.goodsName"
    }],
    attrs: {
      "type": "text",
      "placeholder": "请输入商品名称"
    },
    domProps: {
      "value": (_vm.binFilterObj.goodsName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.binFilterObj, "goodsName", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('span', {
    staticClass: "shelves-input-item"
  }, [_c('label', [_vm._v("二级分类：")]), _vm._v(" "), _c('span', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.binFilterObj.categoryTwoName),
      expression: "binFilterObj.categoryTwoName"
    }],
    attrs: {
      "type": "text",
      "placeholder": "请输入二级分类"
    },
    domProps: {
      "value": (_vm.binFilterObj.categoryTwoName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.binFilterObj, "categoryTwoName", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('span', {
    staticClass: "shelves-input-item"
  }, [_c('label', [_vm._v("三级分类：")]), _vm._v(" "), _c('span', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.binFilterObj.categoryThreeName),
      expression: "binFilterObj.categoryThreeName"
    }],
    attrs: {
      "type": "text",
      "placeholder": "请输入三级级分类"
    },
    domProps: {
      "value": (_vm.binFilterObj.categoryThreeName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.binFilterObj, "categoryThreeName", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('span', {
    staticClass: "shelves-input-item delete-goods-time"
  }, [_c('label', [_vm._v("删除时间：")]), _vm._v(" "), _c('span', {
    staticClass: "delete-time"
  }, [_c('el-date-picker', {
    attrs: {
      "type": "daterange",
      "size": "mini",
      "start-placeholder": "开始日期",
      "end-placeholder": "结束日期"
    },
    model: {
      value: (_vm.binFilterObj.deltime),
      callback: function($$v) {
        _vm.$set(_vm.binFilterObj, "deltime", $$v)
      },
      expression: "binFilterObj.deltime"
    }
  })], 1)]), _vm._v(" "), _c('span', [_c('span', {
    staticClass: "shelves-filter-btn-default shelves-filter",
    on: {
      "click": function($event) {
        return _vm.binFilter(0)
      }
    }
  }, [_vm._v("筛选")]), _vm._v(" "), _c('span', {
    staticClass: "shelves-filter-btn-default shelves-cancel",
    on: {
      "click": _vm.clearbinFilterObj
    }
  }, [_vm._v("取消")])])]), _vm._v(" "), _c('div', [(_vm.isShowbinImg) ? _c('div', {
    staticClass: "noData"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/img/erro@2x.png")
    }
  }), _vm._v(" "), _c('p', [_vm._v("暂未发现任何商品")])]) : _vm._e(), _vm._v(" "), (!_vm.isShowbinImg) ? _c('table', {
    staticClass: "shelves-table"
  }, [_vm._m(1), _vm._v(" "), _c('tbody', _vm._l((_vm.bingoodsList), function(item) {
    return _c('tr', [_c('td', {
      staticClass: "goods-img"
    }, [_c('img', {
      attrs: {
        "src": item.goodsImage
      }
    })]), _vm._v(" "), _c('td', {
      staticClass: "goods-name",
      staticStyle: {
        "padding-left": "50px",
        "text-align": "left"
      }
    }, [_c('span', [_vm._v(_vm._s(item.goodsName))])]), _vm._v(" "), _c('td', [_c('span', [_vm._v(_vm._s(item.brandName))])]), _vm._v(" "), _c('td', [_c('span', [_vm._v(_vm._s(item.createTime))])]), _vm._v(" "), _c('td', {
      staticClass: "operate-button"
    }, [_c('router-link', {
      attrs: {
        "to": {
          name: 'Detail',
          query: {
            goodsId: item.goodsId
          }
        }
      }
    }, [_c('span', [_vm._v("重新加入货架")])])], 1)])
  }), 0)]) : _vm._e()]), _vm._v(" "), (!_vm.isShowbinImg) ? _c('div', {
    staticClass: "block"
  }, [_c('el-pagination', {
    attrs: {
      "layout": "prev, pager, next",
      "current-page": _vm.binFilterObj.pageNum,
      "total": _vm.binGoodsCount,
      "page-size": 50
    },
    on: {
      "current-change": _vm.handlebinCurrentChange,
      "update:currentPage": function($event) {
        return _vm.$set(_vm.binFilterObj, "pageNum", $event)
      },
      "update:current-page": function($event) {
        return _vm.$set(_vm.binFilterObj, "pageNum", $event)
      }
    }
  })], 1) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.carIndex == 1 && _vm.openPurchasingCart == 1) ? _c('shop-car', {
    ref: "shopCar",
    on: {
      "switchPage": _vm.handleSwitchPage
    }
  }) : _vm._e(), _vm._v(" "), (_vm.carIndex == 2 & _vm.openPurchasingCart == 1) ? _c('shop-car-go-order', {
    ref: "shopCarGoOrder",
    on: {
      "switchPage": _vm.handleSwitchPage
    }
  }) : _vm._e(), _vm._v(" "), (_vm.carIndex == 3 & _vm.openPurchasingCart == 1) ? _c('Template-teach', {
    ref: "templateTeach",
    on: {
      "switchPage": _vm.handleSwitchPage
    }
  }) : _vm._e()], 1)]), _vm._v(" "), (_vm.addCarShowFlag && _vm.openPurchasingCart == 1) ? _c('Shop-car-add', {
    ref: "addCar",
    on: {
      "updateListItem": _vm.updateTableData
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "推送方式",
      "visible": _vm.dialogVisible,
      "width": "600px"
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      }
    }
  }, [_c('div', [_c('div', {
    staticClass: "push-content"
  }, [_c('div', {
    staticClass: "push-title"
  }, [_vm._v("温馨提示")]), _vm._v(" "), _c('div', [_vm._v("1.API对接客户：请对接技术自己按对应情况处理平台内接收到的推送信息。如果推送过去没有相应的变化请联系自己对接的技术升级或者查询情况。")]), _vm._v(" "), _c('div', [_vm._v("2.采购车对接客户：不受任何选择影响，建议使用“新商品推送”即可。")])]), _vm._v(" "), _c('div', {
    staticClass: "radio-setting"
  }, [_c('el-radio', {
    attrs: {
      "label": "1"
    },
    model: {
      value: (_vm.radioValue),
      callback: function($$v) {
        _vm.radioValue = $$v
      },
      expression: "radioValue"
    }
  }, [_vm._v("新商品推送")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "2"
    },
    model: {
      value: (_vm.radioValue),
      callback: function($$v) {
        _vm.radioValue = $$v
      },
      expression: "radioValue"
    }
  }, [_vm._v("只推送生效新结算价")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "3"
    },
    model: {
      value: (_vm.radioValue),
      callback: function($$v) {
        _vm.radioValue = $$v
      },
      expression: "radioValue"
    }
  }, [_vm._v("既有商品原链接上更新")])], 1), _vm._v(" "), _c('div', {
    staticClass: "operation",
    staticStyle: {
      "text-align": "center",
      "margin-top": "30px"
    }
  }, [_c('div', {
    staticClass: "batch-operation el-button el-button--primary el-button--small",
    staticStyle: {
      "height": "30px",
      "padding": "0 40px"
    },
    on: {
      "click": function($event) {
        return _vm.newPushSure()
      }
    }
  }, [_c('span', [_vm._v("推送")])])])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', {
    staticClass: "self-tbody-space",
    attrs: {
      "colspan": "11"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("主图")]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "500px"
    }
  }, [_vm._v("商品名称")]), _vm._v(" "), _c('th', [_vm._v("品牌名")]), _vm._v(" "), _c('th', [_vm._v("删除时间")]), _vm._v(" "), _c('th', [_vm._v("操作")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-78da97d7","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Shelves.vue
// module id = 541
// module chunks = 1